import {
  Tabs,
} from "antd";
import React, {
  forwardRef,
  useState,
  useRef,
} from "react";
// import "./CompletedTable.scss";
import State from "@/views/Settings/StateCountyCity/state";
import County from "@/views/Settings/StateCountyCity/county";
import City from "@/views/Settings/StateCountyCity/city";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState('1');
  const stateRef = useRef();
  const countyRef = useRef();
  const cityRef = useRef();

  const handleTabChange = (key) => {
    setTabsKey(key);
    // 切换时调用子组件的刷新方法
    if (key === '1') {
      stateRef.current?.refresh?.();
    } else if (key === '2') {
      countyRef.current?.refresh?.();
    } else if (key === '3') {
      cityRef.current?.refresh?.();
    }
  };

  return (
    <div>
      <Tabs 
        activeKey={tabsKey}
        forceRender
        items={[
          {key: '1', label: "State", children: <State ref={stateRef} />},
          {key: '2', label: "County", children: <County ref={countyRef} />},
          {key: '3', label: "City", children: <City ref={cityRef} />},
        ]}
        onChange={handleTabChange}
      />
    </div>
  );
});
export default MainTable;